import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import useMy from "../../../../../hooks/useMy";
import { ICommentInfo } from "../../../../../pages/Users/Comment";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { Input } from "../../../../Input/Input";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../../Modal/DefaultModalLayout";
import CommentDeleteModal from "./CommentDeleteModal";

import TargetContainer, {
  CommentTargetContainer,
  ModalLabel,
} from "./TargetContainer";
import RadioBtn from "../../../../Button/RadioBtn";
import Blank from "../../../../DefaultStyles/Blank";
import CommentDueDate from "./CommentDueDate";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export interface DefaultModalCommonProps {
  closeEvent: () => void;
  confirmEvent?: () => void;
  type?: "view" | "edit" | "input";
}

interface CommentInputModalProps extends DefaultModalCommonProps {
  commentData?: ICommentInfo;
}

export default function CommentModal({
  closeEvent,
  confirmEvent,
  commentData,
  type,
}: CommentInputModalProps) {
  console.log(commentData);
  const { grade, name } = useMy();

  const modalType = useRecoilValue(defaultModalType);
  const setDefaultModalType = useSetRecoilState(defaultModalType);

  const [targetUid, setTargetUid] = useState(
    commentData
      ? `${commentData?.uid}_${commentData?.name}_${commentData?.nickname}`
      : ""
  );
  const [tag, setTag] = useState(commentData?.tag ? `${commentData?.tag}` : "");
  const [partyBtnClick, setPartyBtnClick] = useState(false);
  const [partyList, setPartyList] = useState<OptionType[]>([]);
  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType>({
    value: commentData?.partyId ?? "",
    label: commentData?.servsubsid
      ? `${getSubsNameBySubsId3(commentData?.servsubsid)}_${
          commentData?.partyId
        }`
      : type === "view"
      ? "해당 없음"
      : "선택",
  });

  const [commentContent, setCommentContent] = useState(
    commentData?.content ? `${commentData?.content}` : ""
  );
  const [inputConfirmBtnClick, setInputConfirmBtnClick] = useState(false);
  const [editConfirmBtnClick, setEditConfirmBtnClick] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [hasDueDate, setHasDueDate] = useState(
    commentData?.duedate ? true : false
  );
  const [dueDate, setDuedate] = useState(
    commentData?.duedate ? commentData?.duedate?.split(" ")[0] : "날짜 선택"
  );
  const [dueDateTime, setDueDateTime] = useState<OptionType>({
    value: commentData
      ? commentData?.duedate?.split(" ")[1]?.split(":")[0]
      : "",
    label: commentData?.duedate
      ? `${commentData?.duedate?.split(" ")[1]?.split(":")[0]}시`
      : "시간 선택",
  });
  const [isComplete, setIsComplete] = useState({
    none: commentData?.iscomp === 2 ? true : commentData ? false : true, // 해당 없음
    false: commentData?.iscomp === 0 ? true : false, // 미해결
    true: commentData?.iscomp === 1 ? true : false, // 해결 완료
  });

  // 해당 유저의 파티 리스트 가져오기
  const {
    response: userPartyResponse,
    error: userPartyError,
    loading: userPartyLoading,
  } = useApi({
    method: "get",
    url:
      targetUid?.split("_")[0] && partyBtnClick
        ? `comment/${targetUid?.split("_")[0]}`
        : undefined,
  });

  // 코멘트 작성
  const {
    response: postResponse,
    error: postError,
    loading: postLoading,
  } = useApi({
    method: "post",
    url: inputConfirmBtnClick ? `comment` : undefined,
    data: {
      uid: Number(targetUid?.split("_")[0]),
      category: tag,
      comment: commentContent,
      partyid:
        subsDropdownValue?.value !== "" ? Number(subsDropdownValue?.value) : 0,
      iscomp: isComplete.none ? 2 : isComplete?.true ? 1 : 0,
      ...(hasDueDate ? { duedate: `${dueDate} ${dueDateTime?.value}:00` } : {}),
    },
  });

  // 코멘트 수정
  const {
    response: editResponse,
    error: editError,
    loading: editLoading,
  } = useApi({
    method: "post",
    url: editConfirmBtnClick ? `comment/${commentData?.commentId}` : undefined,
    data: {
      uid: Number(targetUid?.split("_")[0]),
      category: tag,
      comment: commentContent,
      partyid:
        subsDropdownValue?.value !== "" ? Number(subsDropdownValue?.value) : 0,
      iscomp: isComplete.none ? 2 : isComplete?.true ? 1 : 0,
      ...(hasDueDate ? { duedate: `${dueDate} ${dueDateTime?.value}:00` } : {}),
    },
  });

  useEffect(() => {
    const list = [{ value: "0", label: "해당 없음" }];

    if (userPartyResponse?.status === 200) {
      for (let i = 0; i < userPartyResponse?.data.length; i++) {
        const element = userPartyResponse?.data[i];

        list.push({
          value: `${element?.partyId}`,
          label: `${getSubsNameBySubsId3(element?.servsubsid)}_${
            element?.partyId
          }`,
        });
      }

      if (list.length > 0) {
        setPartyList(list);
      }
    }
  }, [userPartyResponse]);

  const confirmBtnDisabled = () => {
    if (modalType === "edit" && commentData) {
      if (
        targetUid?.includes(commentData?.uid!) &&
        tag === commentData?.tag &&
        commentContent === commentData?.content &&
        (isComplete?.none
          ? commentData?.iscomp === 2
          : isComplete?.false
          ? commentData?.iscomp === 0
          : isComplete?.true
          ? commentData?.iscomp === 1
          : true) &&
        (!(!hasDueDate && isComplete?.none) ||
          !(hasDueDate && !isComplete?.none)) &&
        (hasDueDate
          ? dueDateTime?.value ===
              commentData?.duedate?.split(" ")[1]?.split(":")[0] &&
            dueDate === commentData?.duedate?.split(" ")[0]
          : true)
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (
      !(
        targetUid?.includes("_") &&
        tag !== "" &&
        commentContent !== "" &&
        (hasDueDate
          ? !isComplete?.none &&
            dueDate !== "날짜 선택" &&
            dueDateTime?.value !== ""
          : !hasDueDate && isComplete?.none)
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (editResponse?.status === 200) {
      closeEvent();

      if (confirmEvent) {
        confirmEvent();
      }

      toast.success("코멘트가 수정되었습니다.", {});
    }
  }, [editResponse]);

  useEffect(() => {
    if (postResponse?.status === 201) {
      closeEvent();

      if (confirmEvent) {
        confirmEvent();
      }

      toast.success("코멘트가 추가되었습니다.", {});
    }
  }, [postResponse]);

  useEffect(() => {
    setDefaultModalType(type);
  }, [type]);

  useEffect(() => {
    if (editError) {
      toast.error(userPartyError.data);
    } else if (postError) {
      toast.error(postError.data);
    } else if (userPartyError) {
      toast.error(userPartyError.data);
    }
  }, [editError, postError, userPartyError]);

  return (
    <DefaultModalLayout
      type={type}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (modalType === "input") {
          setInputConfirmBtnClick(true);
        } else if (modalType === "edit") {
          setEditConfirmBtnClick(true);
        } else {
          return;
        }
      }}
      modalTitle={
        modalType === "view"
          ? "코멘트 보기"
          : modalType === "edit"
          ? "코멘트 수정"
          : "코멘트 입력"
      }
      confirmDisabled={confirmBtnDisabled()}
      deleteBtnShow={
        (grade === 1 || commentData?.writer === name) && modalType === "view"
      }
      deleteBtnClickEvent={() => setDeleteModal(true)}
      leftBottomTime={
        modalType === "view" ? commentData?.writeDay ?? undefined : undefined
      }
      leftBottomTitle={
        modalType === "view" ? (commentData ? "작성자" : "관리자") : "관리자"
      }
      leftBottomName={
        modalType === "view" ? commentData?.writer ?? undefined : undefined
      }
      cancelBtnDisabled={
        modalType === "input"
          ? false
          : grade === 1 || commentData?.writer === name
          ? false
          : true
      }
    >
      {/* 대상 */}
      <TargetContainer
        targetUid={targetUid}
        setTargetUid={setTargetUid}
        modalType={type}
      />

      {/* 태그 */}
      <Row>
        <ModalLabel>태그(구분)</ModalLabel>

        <CommentTargetContainer>
          <Input
            placeholder="직접 입력"
            value={tag}
            onChange={(e) => setTag(e.target.value)}
            readOnly={modalType === "view"}
          />
        </CommentTargetContainer>
      </Row>

      {/* 파티 */}
      <Row>
        <ModalLabel>파티</ModalLabel>

        <CommentTargetContainer onClick={() => setPartyBtnClick(true)}>
          {modalType === "input" ? (
            <DropDown
              setDropDownValue={setSubsDropdownValue}
              dropdownValue={subsDropdownValue}
              boxWidth={330}
              optionList={partyList}
              isDisabled={
                modalType !== "input" || !targetUid?.includes("_")
                  ? true
                  : false
              }
              isInModal={false}
            />
          ) : (
            <Input
              value={subsDropdownValue?.label}
              readOnly={modalType !== "input"}
            />
          )}
        </CommentTargetContainer>
      </Row>

      {/* 내용 */}
      <ModalLabel>내용</ModalLabel>

      <Textarea
        placeholder="내용 입력 (필수)"
        required={true}
        value={commentContent}
        onChange={(e) => setCommentContent(e.target.value)}
        readOnly={modalType === "view"}
        maxLength={1000}
        style={{ marginBottom: 12 }}
      />

      {/* 해결 기한 */}
      <CommentDueDate
        hasDueDate={hasDueDate}
        setHasDueDate={setHasDueDate}
        dueDate={dueDate}
        setDuedate={setDuedate}
        dueDateTime={dueDateTime}
        setDueDateTime={setDueDateTime}
        type={modalType}
      />

      <Blank blankHeight={12} marginHeight={12} />

      {/* 해결 여부 */}
      <ModalLabel>해결 여부</ModalLabel>

      <ModalRowContentContainer>
        <RadioBtnContainer>
          <RadioBtn
            label="해당 없음"
            check={isComplete.none}
            clickEvent={() =>
              setIsComplete({
                none: true,
                false: false,
                true: false,
              })
            }
            noTooltip
            sHeight={38}
            disabled={modalType === "view" || hasDueDate}
          />
        </RadioBtnContainer>

        <RadioBtnContainer>
          <RadioBtn
            label="미해결"
            check={isComplete.false}
            clickEvent={() =>
              setIsComplete({
                none: false,
                false: true,
                true: false,
              })
            }
            noTooltip
            sHeight={38}
            disabled={modalType === "view" || !hasDueDate}
          />
        </RadioBtnContainer>

        <RadioBtnContainer>
          <RadioBtn
            label="해결 완료"
            check={isComplete.true}
            clickEvent={() =>
              setIsComplete({
                none: false,
                false: false,
                true: true,
              })
            }
            noTooltip
            sHeight={38}
            disabled={modalType === "view" || !hasDueDate}
          />
        </RadioBtnContainer>
      </ModalRowContentContainer>

      <Blank blankHeight={0} marginHeight={40} />

      {deleteModal ? (
        <CommentDeleteModal
          cancelEvent={() => setDeleteModal(false)}
          commentId={commentData?.commentId}
          closeEvent={() => {
            closeEvent();

            if (confirmEvent) {
              confirmEvent();
            }
          }}
        />
      ) : (
        <></>
      )}

      <>{(editLoading || userPartyLoading || postLoading) && <Loader />}</>
    </DefaultModalLayout>
  );
}

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const RadioBtnContainer = styled.div`
  width: 106px;
  height: 38px;
  display: flex;
  align-items: center;
`;
